import type { GetStaticPropsContext } from "next";
import { server as env } from "@config/env/server";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Container } from "@components/ui";
import { MainLayout } from "@layouts/MainLayout/MainLayout";
import { createClient } from "prismicio";
import { Content } from "@prismicio/client";
import Pedagogique from "@components/pages/Pedagogique/Pedagogique";

import Api from "@middleware/api";
import { CHANNEL_CODES, ICountry } from "@middleware/types";

type PageProps = {
  singleArticle: Content.PedagogiqueDocument;
  bilan: Content.PageBilanDocument;
  countries: ICountry[];
};

export async function getStaticProps({
  locale,
  params,
  previewData,
}: GetStaticPropsContext) {
  const articleSlug = params?.slug;
  const client = createClient({ previewData });
  const articles = await client.getAllByType("pedagogique");
  const singleArticle = articles.find(
    (pedagogique) => pedagogique.uid === articleSlug,
  );
  const bilan = await client.getSingle("page_bilan");
  const channel = await Api.cart.getChannel(CHANNEL_CODES.DIETBON);

  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        "common",
        "header",
        "footer",
        "validation",
      ])),
      singleArticle,
      bilan,
      countries: channel.countries,
    },
    revalidate: parseInt(env.TUNNEL_CONTENT_CACHE),
  };
}

export async function getStaticPaths() {
  const client = createClient();
  const articles = await client.getAllByType("pedagogique");
  const paths = articles.map((article) => ({
    params: { slug: article.uid },
  }));

  return {
    paths: paths,
    fallback: "blocking",
  };
}

const SinglePedagogiquePage = ({
  singleArticle,
  bilan,
  countries,
}: PageProps) => {
  return (
    <Container className="page-cms">
      <Pedagogique page={singleArticle} bilan={bilan} countries={countries} />
    </Container>
  );
};

SinglePedagogiquePage.layout = MainLayout;
export default SinglePedagogiquePage;
